import {
  Button,
  Form,
  InputNumber,
  Modal,
  Select,
  Space,
  Typography,
} from "antd";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import axios from "axios";

const AddDiscount = ({
  open,
  close,
  total,
  po_number_id,
  invoice_number,
  discount_category,
  discount_percentage,
  discount_amount,
  getMerchantInvoiceDetails,
}) => {
  const [selectedDiscountCat, setSelectedDiscountCat] =
    useState(discount_category);
  const [inputtedPercentage, setInputtedPercentage] = useState(
    discount_percentage / 100
  );
  const [inputtedAmount, setInputtedAmount] = useState(discount_amount);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);

  const handleAddDiscount = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("po_number_id", po_number_id);
    formdata.append("invoice_number", invoice_number);
    formdata.append(
      "discountamountinpercentage",
      selectedDiscountCat === "percentage"
        ? parseFloat(total) * parseFloat(inputtedPercentage)
        : ""
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    axios
      .post("user/commissary/add-discount", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Add discount successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      footer={null}
      width={350}
    >
      <Form
        layout="vertical"
        name="basic"
        initialValues={{
          amount: total,
          discount_category,
          discount_percentage,
          discount_amount,
        }}
        onFinish={handleAddDiscount}
        autoComplete="off"
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Form.Item
            name="discount_category"
            label="Discount Category"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select discount category"
              //   onChange={handleGetCityByProvince}
              onChange={(e) => {
                setSelectedDiscountCat(e);
              }}
              size="large"
              showSearch
            >
              <Select.Option value="percentage">Percentage</Select.Option>
              <Select.Option value="amount">Amount</Select.Option>
            </Select>
          </Form.Item>

          {selectedDiscountCat === "percentage" && (
            <Form.Item
              name="discount_percentage"
              label="Percentage"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                //   defaultValue={100}
                min={1}
                max={100}
                size="large"
                style={{ width: "100%" }}
                step="1"
                formatter={(value) => `${value}%`}
                parser={(value) => value.replace("%", "")}
                // onChange={onChange}
                onChange={(value) => {
                  setInputtedPercentage(value / 100);
                  //   console.log("VALUE", value / 100);
                }}
              />
            </Form.Item>
          )}

          {selectedDiscountCat === "amount" && (
            <Form.Item
              name="discount_amount"
              label="Amount"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={0}
                max={999999999999}
                initialvalues={0}
                size="large"
                style={{ width: "100%" }}
                step="0.01"
                onChange={(value) => setInputtedAmount(value)}
              />
            </Form.Item>
          )}

          {selectedDiscountCat !== "" && (
            <>
              {/* percentage */}
              {parseFloat(inputtedPercentage) !== 0 &&
                inputtedPercentage !== "" &&
                selectedDiscountCat === "percentage" && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      border: "1px solid green",
                    }}
                  >
                    <Typography style={{ fontStyle: "italic" }}>
                      Formula: {total} - ({total} * {inputtedPercentage})
                    </Typography>
                    <Typography style={{ fontSize: 22, fontWeight: "bold" }}>
                      &#8369;
                      {parseFloat(
                        parseFloat(total) -
                          parseFloat(total) * parseFloat(inputtedPercentage)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                    <Typography style={{ color: "green", fontWeight: "bold" }}>
                      Discounted Amount
                    </Typography>
                  </div>
                )}
              {/* amount */}
              {parseFloat(inputtedAmount) !== 0 &&
                inputtedAmount !== "" &&
                selectedDiscountCat === "amount" && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      border: "1px solid green",
                    }}
                  >
                    <Typography style={{ fontStyle: "italic" }}>
                      Formula: {total} - {inputtedAmount}
                    </Typography>
                    <Typography style={{ fontSize: 22, fontWeight: "bold" }}>
                      &#8369;
                      {parseFloat(
                        parseFloat(total) - parseFloat(inputtedAmount)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                    <Typography style={{ color: "green", fontWeight: "bold" }}>
                      Discounted Amount
                    </Typography>
                  </div>
                )}
            </>
          )}

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Add"}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Modal>
  );
};

export default AddDiscount;
